<template>
    <div class="album bg-light">
        <div class="alert alert-primary" role="alert">
            {{ nbJeux }} jeux trouv&eacute;s
        </div>
        <div class="row" @click="select(0)">
            <template v-for="jeu in liste">
                <div class="col-sm-6 col-md-4 col-lg-4">
                    <div class="card mb-3 box-shadow" @click.stop="select(jeu.IdJeux)" :class="{indisponible: jeu.StatutJeux_IdStatutJeux != 1}">
                        <!-- <img class="card-img-top" :src="jeu.Photo" style="display: block; max-width:300px; max-height: 150px"> -->
                        <!-- <div style="height:150px">
                            <img :src="jeu.Photo" style="height: 100%">
                            &nbsp;<span class="badge badge-secondary">{{ jeu.CodeJeu }}</span>
                        </div> -->
                        <div style="background-size: cover; background-position: center; background-repeat: no-repeat; height:150px" :style="{backgroundImage: 'url('+jeu.Photo+')'}">
                            &nbsp;<span class="badge badge-secondary">{{ jeu.CodeJeu }}</span>
                        </div>
                        <div class="card-body" style="padding: 0.8rem">
                            <div style="height: 4rem">
                                <span class="card-title">{{ jeu.NomJeu }}</span>
                                <p><small class="text-muted">{{ jeu.NomCreateurJeu }}</small></p>
                            </div>
                            <!-- <div class="d-flex justify-content-between align-items-center">
                                <p><span class="badge badge-info">{{ jeu.NomEmplacement }}</span><br>
                                <span class="badge badge-light">{{ jeu.TypeJeux }}</span></p>
                            </div> -->
                            <div class="d-flex justify-content-between align-items-center">
                                <small class="text-muted">
                                    <template v-if="jeu.AgeMax === '99'"><i class="fas fa-child"></i> {{ jeu.AgeMin }}+</template>
                                    <template v-else-if="jeu.AgeMax === jeu.AgeMin"><i class="fas fa-child"></i> {{ jeu.AgeMin }} ans</template>
                                    <template v-else><i class="fas fa-child"></i> {{ jeu.AgeMin }} - {{ jeu.AgeMax }}</template>
                                </small>
                                <small class="text-muted">
                                    <template v-if="jeu.NbrJoueurMin === jeu.NbrJoueurMax"><i class="fas fa-users"></i> {{ jeu.NbrJoueurMin }}</template>
                                    <template v-else><i class="fas fa-users"></i> {{ jeu.NbrJoueurMin }} - {{ jeu.NbrJoueurMax }}</template>
                                </small>
                                <small class="text-muted">
                                    <template v-if="jeu.DureeMin === jeu.DureeMax"><i class="fas fa-clock"></i> {{ jeu.DureeMin | dureeAffichage }}</template>
                                    <template v-else><i class="fas fa-clock"></i> {{ jeu.DureeMin | dureeAffichage }} - {{ jeu.DureeMax | dureeAffichage }}</template>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="container">
            <button type="button" class="btn btn-primary btn-lg btn-block" @click="next" v-if="liste.length < nbJeux">Voir les jeux suivants</button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['liste', 'nbJeux'],
    data() {
        return {}
    },
    methods: {
        next() {
            this.$emit('next');
        },
        select(id) {
            this.$emit('select', id);
        }
    }
}
</script>

<style scoped>
    .card {
        cursor: pointer;
    }

    .card:hover {
        border: 1px solid rgba(0,0,0,.3);
        background-color: #e2e2e2;
    }

    .indisponible {
        background-color: #ffdddd;
    }
    .indisponible:hover {
        border: 1px solid rgba(0,0,0,.3);
        background-color: #e2b2b2;
    }
</style>


// WEBPACK FOOTER //
// src/components/jeuxliste.vue